import { IStudyProgram, ICourse, IModuleDetail, IPartialResult } from '../models/grade-models';
import GradeListMapper from '../mappings/grade-list-mapper';
import GradeDetailMapper from '../mappings/grade-detail-mapper';

class GradeService {
    private gradeListMapper = new GradeListMapper();
    private gradeDetailMapper = new GradeDetailMapper();

    constructor() {}

    public getAllStudies = (language: string, vuNetId:string, HttpService: any) => {
        return this.getStudies(this.getAllStudiesQuery(language, vuNetId), HttpService);
    }

    public getAllCoursesByStudy = (language: string, vuNetId: string, year: number, studyId: string, HttpService: any) => {
        return this.getCourses(this.getAllCoursesByStudyQuery(language, vuNetId, year, studyId), HttpService);
    }

    public getAllResultsByCourse = (language: string, vuNetId: string, appraisalsId: string, HttpService: any) => {
        return this.getResults(this.getAllResultsByCourseQuery(language, vuNetId, appraisalsId), HttpService);
    }

    public getGradeByStudy = (language: string, vuNetId: string, studyId: string, year: string, bookedModuleId: string, HttpService: any) => {
        return this.getGradeDetail(this.getModuleDetailQuery(language, vuNetId, studyId, year, bookedModuleId), HttpService);
    }
    
    private getStudies = (url: string, HttpService: any): Promise<any> => {
        return new Promise((resolve, reject) => {
            HttpService.get(url).then((result: IStudyProgram[]) => {
                resolve(result.map((entry: IStudyProgram) => this.gradeListMapper.mapStudyProgram(entry)));
            }).catch((error: any) => {
                reject(error)
            });
        });
    }

    private getCourses = (url: string, HttpService: any): Promise<any> => {
        return new Promise((resolve, reject) => {
            HttpService.get(url).then((result: ICourse[]) => {
                resolve(result.map((entry: ICourse) => this.gradeListMapper.mapCourse(entry)));
            }).catch((error: any) => {
                reject(error)
            });
        });
    }

    private getResults = (url: string, HttpService: any): Promise<any> => {
        return new Promise((resolve, reject) => {
            HttpService.get(url).then((result: IPartialResult[]) => {
                resolve(result.map((entry: IPartialResult) => this.gradeListMapper.mapResult(entry)));
            }).catch((error: any) => {
                reject(error)
            });
        });
    }
    
    private getGradeDetail = (url: string, HttpService: any) => {
        return new Promise((resolve, reject) => {
            HttpService.get(url).then((result: IModuleDetail) => {
                resolve(this.gradeDetailMapper.mapGradeDetail(result));
            }).catch((error: any) => {
                reject(error)
            });
        });
    }
    
    private getAllStudiesQuery = (language: string, vuNetId: string): string => {
        if (vuNetId!==null && vuNetId!=='')
            return `/api/students/${language}/${vuNetId}/studies/lastappraised`
        else
            return `/api/students/${language}/studies/lastappraised`
    }

    private getAllCoursesByStudyQuery = (language: string, vuNetId: string, year: number, studyId: string): string => {
        if (vuNetId !== null && vuNetId !== '')
            return `/api/students/${language}/${vuNetId}/studies/${studyId}/years/${year}/gradeswithappraisals`
        else
            return `/api/students/${language}/studies/${studyId}/years/${year}/gradeswithappraisals`
    }

    private getAllResultsByCourseQuery = (language: string, vuNetId: string, appraisalId: string): string => {
        if (vuNetId !== null && vuNetId !== '')
            return `/api/students/${language}/${vuNetId}/appraisals/${appraisalId}/`
        else
            return `/api/students/${language}/appraisals/${appraisalId}/`
    }
    
    private getModuleDetailQuery = (language: string, vuNetId: string, studyId: string, year: string, bookedModuleId: string): string => {
        if (vuNetId !== null && vuNetId !== '')
            return `/api/students/${language}/${vuNetId}/studies/${studyId}/years/${year}/bookedmodules/${bookedModuleId}`
        else 
            return `/api/students/${language}/studies/${studyId}/years/${year}/bookedmodules/${bookedModuleId}`
    }
}

export default new GradeService();